import React from 'react';
import { Form, Col, FormGroup, Row, ListGroup, ListGroupItem } from 'reactstrap';
import Select from 'react-select';

export const FormIndicationProfile = (props) => {
    const {
        // ? INDICATIONS PATIENT
        loading, listIndication, CreateOrUpdateExamIndications, handleSelectValuesIndication, dataIndication,
        // ? INDICATIONs LABORATORY
        dataIndicationLab, listIndicationLab, handleSelectValuesIndication2,
        handleListProfiles,
    } = props;

    const ur_helen = localStorage.getItem("url_helen");
    const isCedimi = ur_helen === 'cedimi';

    return (
        <Form role="form" onSubmit={(e) => e.preventDefault()}>
            <Col sm="12" className='mt-2'>
                <Row>
                    <Col sm="12">
                        <h6 className='txt-danger f-w-500'>Agregar las indicaciones en sus respectivas listas</h6>
                    </Col>

                    {/* Indicaciones Paciente */}
                    <Col sm="6">
                        <Col sm="12" className='mb-2 p-l-0'>
                            <FormGroup>
                                <Select
                                    isMulti
                                    name="listIndication"
                                    value={listIndication}
                                    options={dataIndication}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Selecciona una o varias opciones"
                                    noOptionsMessage={() => "Sin opciones"}
                                    isSearchable={true}
                                    onChange={(e) => handleSelectValuesIndication(e, "listIndication")}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                            minHeight: '38px'
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            padding: '2px 8px',
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999999,
                                        }),
                                    }}
                                />
                            </FormGroup>
                        </Col>

                        <Col sm="12" className='mt-2 p-l-0'>
                            <b className='txt-warning'>Indicaciones para pacientes</b>

                            <ListGroup className="mt-2">
                                {
                                    listIndication.length > 0 ? (
                                        listIndication.map((_find, _key) => (
                                            <ListGroupItem
                                                key={_key}
                                                className="d-flex justify-content-between align-items-center list-group-item-action"
                                            >
                                                <label className='f-w-600 mb-0' style={{ fontSize: "10px" }}>
                                                    {_find?.label ?? "----"}
                                                </label>
                                                <i className="fa fa-check text-success"></i>
                                            </ListGroupItem>
                                        ))
                                    ) : (
                                        <ListGroupItem className="d-flex justify-content-center align-items-center">
                                            <i className='fa fa-warning text-danger'></i>
                                            <label
                                                className='f-w-600 txt-danger mb-0 ml-2'
                                                style={{ fontSize: "11px" }}
                                            >
                                                No se han asignado indicaciones en esta prueba
                                            </label>
                                        </ListGroupItem>
                                    )
                                }
                            </ListGroup>
                        </Col>
                    </Col>

                    {!isCedimi && (
                        <Col sm="6">
                            <Col sm="12" className='mb-2 p-l-0'>
                                <FormGroup>
                                    <Select
                                        isMulti
                                        name="listIndicationLab"
                                        value={listIndicationLab}
                                        options={dataIndicationLab}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Selecciona una o varias opciones"
                                        noOptionsMessage={() => "Sin opciones"}
                                        isSearchable={true}
                                        onChange={(e) => handleSelectValuesIndication2(e, "listIndicationLab")}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                fontSize: '11px',
                                                minHeight: '38px'
                                            }),
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                padding: '2px 8px',
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                fontSize: '11px',
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999999,
                                            }),
                                        }}
                                    />
                                </FormGroup>
                            </Col>

                            <Col sm="12" className='mt-2 p-l-0'>
                                <b className='txt-success'>Indicaciones para laboratorio</b>
                                <ListGroup className='mt-2'>
                                    {
                                        listIndicationLab.length > 0 ? (
                                            listIndicationLab.map((_find, _key) => (
                                                <ListGroupItem key={_key} className="d-flex justify-content-between align-items-center list-group-item-action">
                                                    <label className='f-w-600 mb-0' style={{fontSize:"10px"}}>{_find?.label ?? "----"}</label>
                                                    <i className="fa fa-check text-success"></i>
                                                </ListGroupItem>
                                            ))
                                        ) : (
                                            <ListGroupItem className="d-flex justify-content-center align-items-center">
                                                <i className='fa fa-warning text-danger' ></i>
                                                <label className='f-w-600 txt-danger mb-0 ml-2' style={{fontSize:"11px"}}>No se a asigando indicaciones en esta prueba</label>     
                                            </ListGroupItem>
                                        )
                                    }
                                </ListGroup>
                            </Col>
                        </Col>
                    )}
                </Row>
            </Col>
        </Form>
    );
}
